import { FilterModel } from "model/Filter.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = FilterModel[];

export const useDefaultObservableFilterModelArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectFilterModelArray extends BehaviorSubject<CurrentType> {}
